import { setStyle } from 'redom';
import { MouseCatcher } from '~src/Catchers/mouseCatcher';
import { SystemCamera } from '../System/systemCamera';

// Show text on hoover Logo
export class WaterMark {
    private system: SystemCamera;

    private browser: HTMLElement;

    constructor(
        browser: HTMLElement,
        system: SystemCamera,
        mouseCatcher: MouseCatcher
    ) {
        this.system = system;
        this.browser = browser;
        this.addLogo();
        this.addText();
    }

    private commonStyle = {
        position: 'fixed',
        diplay: 'block',
        opacity: '1',
    };

    private addLogo() {
        const logoHtml = document.createElement('img');
        this.browser.appendChild(logoHtml);

        setStyle(logoHtml, this.commonStyle);
        setStyle(logoHtml, {
            bottom: '19px',
            right: '156px',
            width: '24px',
            height: '24px',
            'border-radius': '3px',
            'pointer-events': 'none',
            'z-index': '100000001',
        });
        logoHtml.src = 'https://d2w9uul1fh5o24.cloudfront.net/editor/main/logo-font.png';
    }

    private addText() {
        const textHtml = document.createElement('p');
        this.browser.appendChild(textHtml);
        setStyle(textHtml, this.commonStyle);
        setStyle(textHtml, {
            bottom: '15px',
            right: '15px',
            width: '170px',
            padding: '8px',
            margin: '0px',
            background: 'black',
            color: 'white',
            'font-size': '14px',
            'text-align': 'right',
            'font-family': 'Arial',
            'border-radius': '3px',
            cursor: 'pointer',
            'z-index': '100000000',
        });
        textHtml.textContent = 'Made with FuryPage';

        textHtml.addEventListener('click', () => {
            window.open('https://fury-page.vercel.app/', '_blank');
        });
    }
}
